import http from "./HttpService";
import { API_BASE_ANALYTICS, API_BASE_CAMPAIGN } from "../../constants/index";
import { getCurrentTime } from "../Analytics/utils";
import axios from "axios";
import store from "store";

const addCampaignsEmailPayload = (
  payload: FormData,
  allCampaigns: boolean,
  excludeList: {
    excludeCampaignsIds: number[];
    excludeAssetsIds: number[];
  },
  includeList: {
    campaignIds: number[];
    emailIds: number[];
  }
) => {
  const { excludeCampaignsIds, excludeAssetsIds } = excludeList;
  const { campaignIds, emailIds } = includeList;
  if (allCampaigns) {
    payload.append("all_campaigns", allCampaigns.toString());
    excludeCampaignsIds?.forEach((campaignId: number) =>
      payload.append("exclude_campaign_ids", campaignId.toString())
    );
    // if emails list is less than exclude emails list
    emailIds?.length < excludeAssetsIds?.length
      ? emailIds?.forEach((emailId: number) => payload.append("include_email_ids", emailId.toString()))
      : excludeAssetsIds?.forEach((emailId: number) => payload.append("exclude_email_ids", emailId.toString()));
  } else {
    if (campaignIds?.length > 0) {
      for (let cid of campaignIds) {
        payload.append("campaign_ids", cid.toString());
      }
    }
    if (emailIds?.length > 0) {
      for (let eid of emailIds) {
        payload.append("email_ids", eid.toString());
      }
    }
  }
};

const addWorkflowsPayload = (payload: FormData, workflowIds: number[]) => {
  let isWorkflow = store.getState().analyticsDashboard.appliedIsWorkflow;
  if (isWorkflow) {
    if (workflowIds?.length > 0) {
      payload.append("all_workflows", "0");
      for (let wid of workflowIds) {
        payload.append("workflow_ids", wid.toString());
      }
      payload.delete("campaign_ids");
      payload.delete("email_ids");
    }
  }
};

let cancelTokenOverview: any;
export const analyticsOverviewService = async (params: any, overview?: boolean) => {
  const payload = new FormData();
  payload.append("advanced_search", "true");
  if (params.startDate) payload.append("start_date", params.startDate);
  if (params.endDate) payload.append("end_date", params.endDate);
  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );
  addWorkflowsPayload(payload, params.workflowIds);

  payload.append("get_overview_data", "1");
  if (params.exportAnalytics) payload.append("export_analytics", "true");
  payload.append("search_creation_datetime", getCurrentTime());

  //Check if there are any previous pending requests
  if (typeof cancelTokenOverview != typeof undefined) {
    cancelTokenOverview && cancelTokenOverview.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenOverview = axios.CancelToken.source();

  return await http.post(`${API_BASE_ANALYTICS}analytics_dashboard/`, payload, {
    cancelToken: cancelTokenOverview.token,
  });
};

let cancelTokenDashboard: any;
export const analyticsDashboardService = async (params: any) => {
  const payload = new FormData();
  payload.append("advanced_search", "true");
  if (params.startDate) payload.append("start_date", params.startDate);
  if (params.endDate) payload.append("end_date", params.endDate);

  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );
  addWorkflowsPayload(payload, params.workflowIds);
  if (params.exportAnalytics) payload.append("export_analytics", "true");
  payload.append("search_creation_datetime", getCurrentTime());

  //Check if there are any previous pending requests
  if (typeof cancelTokenDashboard != typeof undefined) {
    cancelTokenDashboard && cancelTokenDashboard.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenDashboard = axios.CancelToken.source();

  return await http.post(`${API_BASE_ANALYTICS}analytics_dashboard/`, payload, {
    cancelToken: cancelTokenDashboard.token,
  });
};

export const getAnalyticsCampaignsListService = async () => {
  return await http.get(`${API_BASE_CAMPAIGN}get_campaigns/`, {});
};

export const getAnalyticsAssetsListService = async () => {
  return await http.get(`${API_BASE_CAMPAIGN}get_asset_browser_content/`, {});
};

let cancelTokenGraphData: any;
export const getAnalyticsGraphDataService = async (params: any) => {
  const payload = new FormData();

  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );
  addWorkflowsPayload(payload, params.workflowIds);

  payload.append("analytic_request", "1");
  if (params.startDate) payload.append("start_date", params.startDate);
  if (params.endDate) payload.append("end_date", params.endDate);
  if (params.exportAnalytics) payload.append("export_analytics", params.exportAnalytics);
  //Check if there are any previous pending requests
  if (typeof cancelTokenGraphData != typeof undefined) {
    cancelTokenGraphData && cancelTokenGraphData.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenGraphData = axios.CancelToken.source();

  return await http.post(
    `${API_BASE_ANALYTICS}campaigns_analytics/`,
    payload,
    { cancelToken: cancelTokenGraphData.token } //Pass the cancel token to the current request
  );
};

let cancelTokenCampaignAsset: any;
export const getAnalyticsCampaignsAssetsListService = async () => {
  //Check if there are any previous pending requests
  if (typeof cancelTokenCampaignAsset != typeof undefined) {
    cancelTokenCampaignAsset && cancelTokenCampaignAsset.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenCampaignAsset = axios.CancelToken.source();

  return await http.get(`${API_BASE_ANALYTICS}dashboard_campaign_emails/`, {
    cancelToken: cancelTokenCampaignAsset.token,
  });
};

export const getAnalyticsWorkflowListService = async () => {
  return await http.get(`${API_BASE_ANALYTICS}dashboard_workflows/`);
};

let cancelTokenCampaigns: any;
export const getAnalyticsSelectedCampaignsAssetsListService = async (
  campaignIds: string | any[] | undefined = []
) => {
  let payload = new FormData();
  if (campaignIds) {
    for (let cid of campaignIds) {
      payload.append("campaign_ids", cid);
    }
  }
  //Check if there are any previous pending requests
  if (typeof cancelTokenCampaigns != typeof undefined) {
    cancelTokenCampaigns && cancelTokenCampaigns.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenCampaigns = axios.CancelToken.source();

  return await http.post(`${API_BASE_ANALYTICS}dashboard_campaign_emails/`, payload, {
    cancelToken: cancelTokenCampaigns.token,
  });
};

export const exportAnalyticsDataService = async (campaign_ids: any[], asset_ids: any[], ssid: any) => {
  const payload = new FormData();
  payload.append("action", "overview_stats_cards");
  payload.append("campaign_id", "");
  payload.append("asset_id", campaign_ids.join(","));
  payload.append("version_id", asset_ids.join(","));
  payload.append("saved_search_id", ssid);
  payload.append("time_diff", "");
  payload.append("export_analytics", "true");

  return await http.post(`${API_BASE_ANALYTICS}export/`, payload);
};

let cancelTokenContactAnalytics: any;
//Contacts analytics
export const getContactsListService = async (params: any, isAccounts?: boolean) => {
  const payload = new FormData();
  if (params.tab) payload.append("tab", params.tab);
  if (params.limit !== undefined) payload.append("limit", params.limit);
  if (params.offset !== undefined) payload.append("offset", params.offset);
  if (params.searchWord !== undefined && params.searchWord.trim() !== "")
    payload.append("search_word", params.searchWord);
  if (params.sortType && params.sortType !== "none") {
    payload.append("sort_type", params.sortType);
    payload.append("sort_by", params.sortBy);
  }

  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );

  addWorkflowsPayload(payload, params.workflowIds);

  payload.append("start_date", params.startDate);
  payload.append("end_date", params.endDate);
  if (params.accountId) payload.append("account_id", params.accountId);
  if (params.contactsByFilter) payload.append("contacts_by_filter", params.contactsByFilter);
  if (params.exportAnalytics) payload.append("export_analytics", "true");

  if (isAccounts) {
    //Check if there are any previous pending requests
    if (typeof cancelTokenContactAnalytics != typeof undefined) {
      cancelTokenContactAnalytics && cancelTokenContactAnalytics.cancel("Operation canceled due to new request.");
    }
    //Save the cancel token for the current request
    cancelTokenContactAnalytics = axios.CancelToken.source();

    return await http.post(
      `${API_BASE_ANALYTICS}contacts_listing/`,
      payload,
      { cancelToken: cancelTokenContactAnalytics.token } //Pass the cancel token to the current request
    );
  } else {
    return await http.post(`${API_BASE_ANALYTICS}contacts_listing/`, payload);
  }
};

let cancelTokenContactContent: any;
//content articles for contacts in analytics
export const getContentArticlesContactsService = async (params: any) => {
  const payload = new FormData();
  payload.append("contact_id", params.contact_id);
  payload.append("limit", params.limit);
  payload.append("offset", params.offset);
  if (params.sort_type && params.sort_type !== "none") {
    payload.append("order_by", params.sort_type);
    payload.append("sort_by", params.sort_by);
  }

  //Check if there are any previous pending requests
  if (typeof cancelTokenContactContent != typeof undefined) {
    cancelTokenContactContent && cancelTokenContactContent.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenContactContent = axios.CancelToken.source();

  return await http.post(`${API_BASE_ANALYTICS}contact_content_engagement/`, payload, {
    cancelToken: cancelTokenContactContent.token,
  });
};

let cancelTokenContactDashboard: any;
//contact dashboard for analytics
export const getContactDashboardService = async (params: any) => {
  const payload = new FormData();
  payload.append("contact_id", params.contact_id);
  payload.append("limit", params.limit);
  payload.append("offset", params.offset);

  //Check if there are any previous pending requests
  if (typeof cancelTokenContactDashboard != typeof undefined) {
    cancelTokenContactDashboard && cancelTokenContactDashboard.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenContactDashboard = axios.CancelToken.source();

  return await http.post(`${API_BASE_ANALYTICS}contact_dashboard/`, payload, {
    cancelToken: cancelTokenContactDashboard.token,
  });
};

let cancelTokenAccountAnalytics: any;
export const getAccountsListService = async (params: any) => {
  const payload = new FormData();

  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );

  addWorkflowsPayload(payload, params.workflowIds);

  if (params.limit !== undefined) payload.append("limit", params.limit);
  if (params.offset !== undefined) payload.append("offset", params.offset);
  if (params.sortBy && params.sortBy !== "none") {
    payload.append("sort_by", params.sortBy);
    payload.append("order_by", params.orderBy);
  }
  if (params.searchWord !== undefined && params.searchWord !== "")
    payload.append("search_account", params.searchWord);
  if (params.startDate) payload.append("start_date", params.startDate);
  if (params.endDate) payload.append("end_date", params.endDate);
  if (params.exportAnalytics) payload.append("export_analytics", "true");

  //Check if there are any previous pending requests
  if (typeof cancelTokenAccountAnalytics != typeof undefined) {
    cancelTokenAccountAnalytics && cancelTokenAccountAnalytics.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenAccountAnalytics = axios.CancelToken.source();

  return await http.post(`${API_BASE_ANALYTICS}accounts_listing/`, payload, {
    cancelToken: cancelTokenAccountAnalytics.token,
  });
};

let cancelTokenContentAnalytics: any;
export const getContentListService = async (params: any) => {
  const payload = new FormData();

  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );

  addWorkflowsPayload(payload, params.workflowIds);

  if (params.limit !== undefined) payload.append("limit", params.limit);
  if (params.offset !== undefined) payload.append("offset", params.offset);
  if (params.searchWord !== undefined && params.searchWord !== "")
    payload.append("search_content", params.searchWord);
  if (params.sortBy && params.sortBy !== "none") {
    payload.append("sort_by", params.sortBy);
    payload.append("order_by", params.orderBy);
  }
  payload.append("start_date", params.startDate);
  payload.append("end_date", params.endDate);
  if (params.exportAnalytics) payload.append("export_analytics", "true");

  //Check if there are any previous pending requests
  if (typeof cancelTokenContentAnalytics != typeof undefined) {
    cancelTokenContentAnalytics && cancelTokenContentAnalytics.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenContentAnalytics = axios.CancelToken.source();

  return await http.post(`${API_BASE_ANALYTICS}content_listing/`, payload, {
    cancelToken: cancelTokenContentAnalytics.token,
  });
};

let cancelTokenContentEngagement: any;
export const getContentEngagementListService = async (params: any) => {
  const payload = new FormData();
  payload.append("account_id", params.accountId);
  if (params.limit !== undefined) payload.append("limit", params.limit);
  if (params.offset !== undefined) payload.append("offset", params.offset);
  if (params.searchWord) payload.append("search_term", params.searchWord);
  if (params.sortBy) payload.append("sort_by", params.sortBy);
  if (params.orderBy !== undefined && params.orderBy !== "none") payload.append("order_by", params.orderBy);

  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );
  if (params.startDate) payload.append("start_date", params.startDate);
  if (params.endDate) payload.append("end_date", params.endDate);
  if (params.exportAnalytics) payload.append("export_analytics", "true");
  addWorkflowsPayload(payload, params.workflowIds);

  //Check if there are any previous pending requests
  if (typeof cancelTokenContentEngagement != typeof undefined) {
    cancelTokenContentEngagement && cancelTokenContentEngagement.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenContentEngagement = axios.CancelToken.source();

  return await http.post(`${API_BASE_ANALYTICS}account_content_engagement/`, payload, {
    cancelToken: cancelTokenContentEngagement.token,
  });
};

let cancelTokenAccountDetails: any;
export const getAccountsDashboardService = async (params: any) => {
  const payload = new FormData();
  payload.append("account_id", params.account_id);

  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaign_ids,
      emailIds: params.email_ids,
    }
  );
  if (params.start_date && params.end_date) {
    payload.append("start_date", params.start_date);
    payload.append("end_date", params.end_date);
  }
  addWorkflowsPayload(payload, params.workflowIds);

  //Check if there are any previous pending requests
  if (typeof cancelTokenAccountDetails != typeof undefined) {
    cancelTokenAccountDetails && cancelTokenAccountDetails.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenAccountDetails = axios.CancelToken.source();

  return await http.post(`${API_BASE_ANALYTICS}account_details/`, payload, {
    cancelToken: cancelTokenAccountDetails.token,
  });
};

let cancelTokenDeliveredContactAnalytics: any;
//Contacts analytics
export const getDeliveredContactsListService = async (params: any, isAccounts?: boolean) => {
  const payload = new FormData();
  if (params.tab) payload.append("tab", params.tab);
  if (params.limit !== undefined) payload.append("limit", params.limit);
  if (params.offset !== undefined) payload.append("offset", params.offset);
  if (params.searchWord !== undefined && params.searchWord.trim() !== "")
    payload.append("search_word", params.searchWord);
  if (params.sortType && params.sortType !== "none") {
    payload.append("sort_type", params.sortType);
    payload.append("sort_by", params.sortBy);
  }

  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );

  addWorkflowsPayload(payload, params.workflowIds);

  payload.append("start_date", params.startDate);
  payload.append("end_date", params.endDate);
  if (params.accountId) payload.append("account_id", params.accountId);
  if (params.contactsByFilter) payload.append("contacts_by_filter", params.contactsByFilter);
  if (params.exportAnalytics) payload.append("export_analytics", "true");

  //Check if there are any previous pending requests
  if (typeof cancelTokenDeliveredContactAnalytics != typeof undefined) {
    cancelTokenDeliveredContactAnalytics &&
      cancelTokenDeliveredContactAnalytics.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenDeliveredContactAnalytics = axios.CancelToken.source();

  return await http.post(
    `${API_BASE_ANALYTICS}contacts_listing/`,
    payload,
    { cancelToken: cancelTokenDeliveredContactAnalytics.token } //Pass the cancel token to the current request
  );
};

let cancelBouncedTokenContactAnalytics: any;
//Contacts analytics
export const getBouncedContactsListService = async (params: any, isAccounts?: boolean) => {
  const payload = new FormData();
  if (params.tab) payload.append("tab", params.tab);
  if (params.limit !== undefined) payload.append("limit", params.limit);
  if (params.offset !== undefined) payload.append("offset", params.offset);
  if (params.searchWord !== undefined && params.searchWord.trim() !== "")
    payload.append("search_word", params.searchWord);
  if (params.sortType && params.sortType !== "none") {
    payload.append("sort_type", params.sortType);
    payload.append("sort_by", params.sortBy);
  }

  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );

  addWorkflowsPayload(payload, params.workflowIds);

  payload.append("start_date", params.startDate);
  payload.append("end_date", params.endDate);
  if (params.accountId) payload.append("account_id", params.accountId);
  if (params.contactsByFilter) payload.append("contacts_by_filter", params.contactsByFilter);
  if (params.exportAnalytics) payload.append("export_analytics", "true");

  //Check if there are any previous pending requests
  if (typeof cancelBouncedTokenContactAnalytics != typeof undefined) {
    cancelBouncedTokenContactAnalytics &&
      cancelBouncedTokenContactAnalytics.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelBouncedTokenContactAnalytics = axios.CancelToken.source();

  return await http.post(
    `${API_BASE_ANALYTICS}contacts_listing/`,
    payload,
    { cancelToken: cancelBouncedTokenContactAnalytics.token } //Pass the cancel token to the current request
  );
};

let cancelTokenUnsubscribedContactAnalytics: any;
//Contacts analytics
export const getUnsubscribedContactsListService = async (params: any, isAccounts?: boolean) => {
  const payload = new FormData();
  if (params.tab) payload.append("tab", params.tab);
  if (params.limit !== undefined) payload.append("limit", params.limit);
  if (params.offset !== undefined) payload.append("offset", params.offset);
  if (params.searchWord !== undefined && params.searchWord.trim() !== "")
    payload.append("search_word", params.searchWord);
  if (params.sortType && params.sortType !== "none") {
    payload.append("sort_type", params.sortType);
    payload.append("sort_by", params.sortBy);
  }

  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );

  addWorkflowsPayload(payload, params.workflowIds);

  payload.append("start_date", params.startDate);
  payload.append("end_date", params.endDate);
  if (params.accountId) payload.append("account_id", params.accountId);
  if (params.contactsByFilter) payload.append("contacts_by_filter", params.contactsByFilter);
  if (params.exportAnalytics) payload.append("export_analytics", "true");

  //Check if there are any previous pending requests
  if (typeof cancelTokenUnsubscribedContactAnalytics != typeof undefined) {
    cancelTokenUnsubscribedContactAnalytics &&
      cancelTokenUnsubscribedContactAnalytics.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenUnsubscribedContactAnalytics = axios.CancelToken.source();

  return await http.post(
    `${API_BASE_ANALYTICS}contacts_listing/`,
    payload,
    { cancelToken: cancelTokenUnsubscribedContactAnalytics.token } //Pass the cancel token to the current request
  );
};

let cancelTokenGetEmailTrendsService: any;

export const getEmailTrendsService = async (params: any) => {
  const payload = new FormData();
  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );
  payload.append("start_date", params.startDate);
  payload.append("end_date", params.endDate);

  addWorkflowsPayload(payload, params.workflowIds);

  //Check if there are any previous pending requests
  if (typeof cancelTokenGetEmailTrendsService != typeof undefined) {
    cancelTokenGetEmailTrendsService &&
      cancelTokenGetEmailTrendsService.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenGetEmailTrendsService = axios.CancelToken.source();

  if (params.exportAnalytics) payload.append("export_analytics", "true");

  return await http.post(
    `${API_BASE_ANALYTICS}email_trends_graph/`,
    payload,
    { cancelToken: cancelTokenGetEmailTrendsService.token } //Pass the cancel token to the current request
  );
};

let cancelTokenGetClickTrendsService: any;

export const getClickTrendsService = async (params: any) => {
  const payload = new FormData();
  addCampaignsEmailPayload(
    payload,
    params.allCampaigns,
    {
      excludeCampaignsIds: params.excludeCampaignsIds,
      excludeAssetsIds: params.excludeAssetsIds,
    },
    {
      campaignIds: params.campaignIds,
      emailIds: params.emailIds,
    }
  );

  payload.append("start_date", params.startDate);
  payload.append("end_date", params.endDate);

  addWorkflowsPayload(payload, params.workflowIds);

  //Check if there are any previous pending requests
  if (typeof cancelTokenGetClickTrendsService != typeof undefined) {
    cancelTokenGetClickTrendsService &&
      cancelTokenGetClickTrendsService.cancel("Operation canceled due to new request.");
  }
  //Save the cancel token for the current request
  cancelTokenGetClickTrendsService = axios.CancelToken.source();

  if (params.exportAnalytics) payload.append("export_analytics", "true");

  return await http.post(
    `${API_BASE_ANALYTICS}click_trends_graph/`,
    payload,
    { cancelToken: cancelTokenGetClickTrendsService.token } //Pass the cancel token to the current request
  );
};
